@if (this.data.isFromGuide) {
  <div class="progress-bar-container"></div>
}
<div class="modal-root-mobile-full" (keydown.enter)="$event.preventDefault()">
  <modal-header [title]="'connectAnAccount' | i18n" (onBackClicked)="onBackClick()"></modal-header>

  <div class="modal-body">
    <div class="tw-w-full tw-m-3 tw-bg-accent"></div>

    <div [ngClass]="this.data.isFromGuide ? 'min-md:tw-w-[70%]' : 'tw-w-full'">
      <app-search-input
        [placeholder]="'searchPlugins' | i18n"
        [(value)]="searchQuery"
        [flat]="true"
      ></app-search-input>
    </div>

    <div class="tw-flex tw-flex-row tw-gap-2 sm:tw-flex-col">
      <div class="tw-flex tw-flex-col tw-gap-8" [ngClass]="contentClass">
        <div class="tw-flex tw-flex-col tw-gap-2 tw-mt-6">
          <span
            class="tw-font-montserrat tw-font-semibold tw-uppercase tw-tracking-[0.7px] tw-text-color-text-secondary"
            *ngIf="hasAnyResults()"
            >{{ "myPlugins" | i18n }}</span
          >

          <div
            appGlossScroll
            class="tw-flex tw-flex-col tw-w-full tw-gap-3 tw-h-fit tw-max-h-[280px] tw-overflow-y-auto tw-p-1 tw-overscroll-contain"
          >
            <!-- Australia — Fiskil (CDR) -->
            <div
              *ngIf="showFiskil()"
              class="tw-flex tw-flex-col tw-w-full tw-p-4 tw-gap-3 tw-rounded-2xl tw-bg-color-surface-input tw-shadow-elevation-card tw-transition-colors"
              [ngClass]="
                isConnectingToFiskil()
                  ? 'tw-cursor-wait'
                  : 'tw-cursor-pointer hover:tw-bg-color-surface-elevated'
              "
              [attr.aria-busy]="isConnectingToFiskil()"
              (click)="goWithFiskil()"
            >
              <span class="tw-font-medium">{{ "connectAustralianBankAccounts" | i18n }}</span>
              <div class="tw-flex tw-w-full tw-items-center tw-justify-between">
                <bank-icons [banks]="getBanks('AU')" iconName="more"></bank-icons>
                @if (isConnectingToFiskil()) {
                  <div
                    class="tw-flex tw-items-center tw-gap-2 tw-text-color-text-secondary"
                    role="status"
                  >
                    <span
                      class="tw-inline-block tw-w-4 tw-h-4 tw-rounded-full tw-border-2 tw-border-primary tw-border-t-transparent tw-animate-spin"
                    ></span>
                    {{ "connectingToFiskil" | i18n }}
                  </div>
                } @else {
                  <div class="tw-flex tw-items-center tw-gap-1">
                    Powered by | <img src="images/fiskil.svg" alt="Fiskil" class="tw-h-4" />
                  </div>
                }
              </div>
            </div>

            <!-- United States — Plaid (beta) -->
            <div
              *ngIf="showPlaidTile()"
              class="tw-flex tw-flex-col tw-w-full tw-p-4 tw-gap-3 tw-rounded-2xl tw-bg-color-surface-input tw-shadow-elevation-card hover:tw-bg-color-surface-elevated tw-transition-colors tw-cursor-pointer"
              (click)="goWithPlaid()"
            >
              <span class="tw-font-medium">{{ "connectUsAccounts" | i18n }}</span>
              <div class="tw-flex tw-w-full tw-items-center tw-justify-between">
                <bank-icons [banks]="getBanks('US')"></bank-icons>
                <div class="tw-flex tw-items-center tw-gap-1">
                  Powered by <span class="tw-font-semibold">Plaid</span>
                </div>
              </div>
            </div>

            <span
              class="tw-font-medium tw-text-color-text-disabled tw-mt-2"
              *ngIf="filteredInstalledPluginIds().length > 0"
              >INSTALLED PLUGINS</span
            >

            <!-- Installed Plugin Cards - Show only those that match search -->
            <div
              *ngIf="filteredInstalledPluginIds().length > 0"
              class="tw-grid tw-grid-cols-4 tw-gap-3 md:tw-grid-cols-2"
            >
              <installed-plugin-card
                *ngFor="let pluginId of filteredInstalledPluginIds()"
                [pluginId]="pluginId"
                (click)="onPluginCardClick(pluginId)"
              ></installed-plugin-card>
            </div>

            <!-- No Results Message -->
            <div *ngIf="!hasAnyResults()" class="tw-flex tw-flex-wrap tw-gap-1">
              <span class="tw-text-color-text-secondary tw-text-center">
                Can't find the plugin you are looking for?
              </span>
              <button
                class="tw-text-color-status-info-text tw-underline tw-cursor-pointer hover:tw-opacity-70"
                (click)="goToPluginsPage()"
              >
                Explore all available Plugins
              </button>
            </div>
          </div>
        </div>

        <div
          class="tw-flex tw-w-full tw-justify-between tw-items-center xs:tw-flex-col"
          *appRoleScope="'BETA_ACCESS'"
        >
          <span
            class="tw-font-montserrat tw-font-bold tw-text-sm tw-leading-[16.5px] tw-tracking-normal tw-text-color-text-tertiary"
            >Explore Available Plugins</span
          >
          <div class="tw-flex tw-gap-1 tw-items-end tw-cursor-pointer" (click)="goToPluginsPage()">
            <span
              class="tw-font-montserrat tw-font-bold tw-text-base tw-leading-tight tw-text-color-text-action tw-underline tw-decoration-color-text-action"
              >View Plugins</span
            >
            <icon name="link" [size]="5" [currentColor]="'color-text-action'"></icon>
          </div>
        </div>
      </div>

      <ng-container *ngIf="this.data.isFromGuide">
        <app-task-info-tooltips
          [taskTitle]="'fetchAnAccount'"
          [taskDescription]="'fetchAccountDesc'"
          [bottomAction]="'none'"
        ></app-task-info-tooltips>
      </ng-container>
    </div>
  </div>
</div>
